import { cn } from 'utils/style'

export type LabelProps = {
	text: string | undefined
	disabled?: boolean
	htmlFor?: string
	required?: boolean
}

export const Label = ({ text, htmlFor, disabled = false, required = false }: LabelProps) => {
	if (!text) return null

	return (
		<label
			htmlFor={htmlFor}
			className={cn('text-xs font-semibold leading-4 text-foreground', disabled && 'opacity-50')}>
			{text}
			{required ? <span className="ml-0.5 text-danger">*</span> : null}
		</label>
	)
}
